// layouts
import ArmilisLayout from "../ArmilisLayout/ArmilisLayout";
import TrustConserveLayout from "../TrustConserveLayout/TrustConserveLayout";
import AMGLayout from "../AMGLayout/AMGLayout";
import AlsaLayout from "../AlsaLayout/AlsaLayout";
import WilktronicsXArmilisLayout from "../WilktronicsXArmilis/WilktronicsXArmilisLayout";
import _jZP9Zja79jLayout from "../TagsLayout/_jZP9Zja79jLayout/_jZP9Zja79jLayout";
import TrustConserveDefault from "../TrustConserveLayout/TrustConserveDefault";
import DefaultLayout from "layouts/DefaultLayout/DefaultLayout";

// A ---------------------------------------------------------------------- M

import { ArmilisTheme, TrustConserveTheme, AMGTheme, AlsaTheme, WilktronicsXArmilisTheme, _jZP9Zja79jTheme, DefaultTheme } from "themes/themeConfig";

export const layoutRegistry = {
  armilis: { layout: ArmilisLayout, theme: ArmilisTheme },
  trustConserve: { layout: TrustConserveLayout, theme: TrustConserveTheme },
  trustConserveDefault: { layout: TrustConserveDefault, theme: TrustConserveTheme },
  amg: { layout: AMGLayout, theme: AMGTheme },
  alsa: { layout: AlsaLayout, theme: AlsaTheme },
  wilktronics: { layout: WilktronicsXArmilisLayout, theme: WilktronicsXArmilisTheme },
  jzp9zja79j: { layout: _jZP9Zja79jLayout, theme: _jZP9Zja79jTheme },
  default: { layout: DefaultLayout, theme: DefaultTheme },
};
